module.exports = __webpack_public_path__ + "static/media/trio.72975d0e.webp";